import React from 'react';
import { Typography } from '@mui/material';
import { CARD_PADDING } from '../caseStatusTheme';
import { useCaseStatusLanguage } from '../../../../routes/CaseStatus/CaseStatusLanguageProvider';

// Shared "Case <number>" page heading used by both the case status and payment result pages.
const CaseHeading = ({ caseNumber }: { caseNumber: string }) => {
  const { t } = useCaseStatusLanguage();
  return (
    <Typography variant="h5" component="h1" sx={{ mb: 2.5, fontWeight: 700, pl: CARD_PADDING }}>
      {t('CaseLabel')} {caseNumber}
    </Typography>
  );
};

export default CaseHeading;
